import { CoreChargeWorkoutHomeCardListSkeleton } from '../core-charge-workout-card-list/core-charge-workout-card-list-skeleton'
import { Container, Row } from 'react-bootstrap'
import { CoreChargeWorkoutCardList } from 'src/component/core-charge-workout-card-list/core-charge-workout-card-list'
import { ForwardArrowLink } from 'src/component/forward-arrow-link/forward-arrow-link'
import { SectionTitle } from 'src/component/ui/section-title'
import { useCoreChargeWorkouts } from 'src/hook/use-workouts'

export const CoreChargeWorkouts = (): React.ReactElement => {
  const { data: workouts = [], isLoading } = useCoreChargeWorkouts({ pageSize: 3, page: 1 })

  if (!workouts && !isLoading) return <></>

  return (
    <Container className="text-black w-full pt-10 pb-12 flex flex-col gap-12">
      <Row className="flex flex-nowrap justify-between items-center gap-4">
        <SectionTitle>Core charge</SectionTitle>
        <div className="flex-shrink-0">
          <ForwardArrowLink text="See All" link="/core-charge-workouts" theme="dark" />
        </div>
      </Row>
      {isLoading ? <CoreChargeWorkoutHomeCardListSkeleton /> : <CoreChargeWorkoutCardList workouts={workouts} />}
    </Container>
  )
}
